// extracted by mini-css-extract-plugin
export default {"button":"RemoveSegment-module__button___UJSEp","icon":"RemoveSegment-module__icon___Vkpdc"};